const CodeCharacters = ({generatedCode} : {generatedCode: string}) => {
    return (
        <div className="code-container">
            {generatedCode.split("").map((char, index) => (
                <div key={index} className="code-character" data-testid="code-character">
                    {char}
                </div>
            ))}
        </div>
    );
}

export default CodeCharacters;
